import { render, staticRenderFns } from "./ResalesRegistration.vue?vue&type=template&id=ead6fc54&scoped=true"
import script from "./ResalesRegistration.vue?vue&type=script&lang=js"
export * from "./ResalesRegistration.vue?vue&type=script&lang=js"
import style0 from "./ResalesRegistration.vue?vue&type=style&index=0&id=ead6fc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead6fc54",
  null
  
)

export default component.exports